import React from 'react';
import {
  BUILDER_BLOCKS,
  canPlaceInSlot,
  type EcoRitmoSessionConfig,
  type WagonRef,
} from '../../lib/rhythm/ecoRitmoConfig';
import type { RhythmFigureId } from '../../lib/rhythm/rhythmTokens';
import { RhythmFigureIcon } from './RhythmFigureIcon';

interface EcoBlockPaletteProps {
  config: EcoRitmoSessionConfig;
  selectedWagon: WagonRef;
  onAddFigure: (fig: RhythmFigureId) => void;
  dragFigure: RhythmFigureId | null;
  onDragFigure: (fig: RhythmFigureId | null) => void;
}

export const EcoBlockPalette: React.FC<EcoBlockPaletteProps> = ({
  config,
  selectedWagon,
  onAddFigure,
  dragFigure,
  onDragFigure,
}) => {
  const slots = config.pattern[selectedWagon.measureIndex] ?? [];

  return (
    <aside className="eco-palette paleta-bloques shrink-0 flex flex-col overflow-hidden">
      <div className="eco-palette-header px-3 py-3 text-center">
        <span className="eco-palette-title">Paleta de bloques</span>
      </div>
      <div className="eco-palette-body eco-scroll-hidden flex-1 flex flex-col gap-2 p-2 min-h-0">
        {BUILDER_BLOCKS.map((block) => {
          const disabled = !canPlaceInSlot(
            slots,
            selectedWagon.slotIndex,
            block.figureId,
            config.timeSignature
          );
          const isDragging = dragFigure === block.figureId;
          return (
            <button
              key={block.figureId}
              type="button"
              disabled={disabled}
              draggable={!disabled}
              onDragStart={(e) => {
                onDragFigure(block.figureId);
                e.dataTransfer.setData('text/eco-figure', block.figureId);
                e.dataTransfer.effectAllowed = 'copy';
              }}
              onDragEnd={() => onDragFigure(null)}
              onClick={() => !disabled && onAddFigure(block.figureId)}
              className={`eco-block-btn flex flex-col items-center gap-1 py-2 px-1.5 transition-all disabled:opacity-30 disabled:pointer-events-none ${
                isDragging ? 'eco-block-btn--dragging' : ''
              }`}
              style={
                {
                  color: block.color,
                  ['--block-accent' as string]: block.border,
                } as React.CSSProperties
              }
              title={block.label}
            >
              <RhythmFigureIcon figureId={block.figureId} size={58} color={block.color} />
              <span className="eco-block-label">{block.label}</span>
            </button>
          );
        })}
      </div>
    </aside>
  );
};

export default EcoBlockPalette;
